import { handleAxiosDates } from '@shared/utils/dateUtil';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';

// // console.log('process.env.REACT_APP_BASE_URL', process.env.REACT_APP_BASE_URL);
export const api_ = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

//* 강제 로그아웃 후 로그인 페이지에서 안내 메시지를 띄우기 위한 플래그 (App.tsx에서 소비)
export const FORCED_LOGOUT_NOTICE_KEY = 'forcedLogoutNotice';

// 로그인/회원가입류 엔드포인트의 401은 "비밀번호 오류"라 세션 무효와 무관 (verifyCurrentPassword 포함)
const isCredentialEndpoint = (url?: string) =>
  !!url && (url.includes('auth/login') || url.includes('auth/signup'));

let forcedLogoutInProgress = false;

/**
 * 토큰을 실었는데도 401이면(다른 서버용 토큰의 invalid signature, 만료 등) 세션이 무효한 것.
 * 인증정보를 비우고 리로드하면 각 포털의 라우트 가드가 자기 로그인 페이지로 보낸다.
 * 서버가 401을 응답한 경우에만 동작: 타임아웃/네트워크 단절(response 없음), 404/403 등은 건드리지 않는다.
 * 토큰 없이 받은 401(게스트)도 제외 — 로그아웃 후 재시도가 무한 리로드로 이어지지 않게 하는 안전장치.
 */
const forceLogoutOnInvalidSession = (error: AxiosError) => {
  const config = error?.config;
  const headers = config?.headers as any;
  const sentToken = !!(
    headers?.Authorization ??
    headers?.authorization ??
    headers?.get?.('Authorization')
  );
  if (
    error?.response?.status === 401 &&
    sentToken &&
    !isCredentialEndpoint(config?.url) &&
    !forcedLogoutInProgress
  ) {
    forcedLogoutInProgress = true;
    localStorage.removeItem('token');
    localStorage.removeItem('userProfile');
    localStorage.removeItem('userBugoBrand');
    sessionStorage.removeItem('token');
    sessionStorage.setItem(FORCED_LOGOUT_NOTICE_KEY, '1');
    window.location.reload();
  }
  return Promise.reject(error);
};

api_.interceptors.request.use((config: AxiosRequestConfig) => {
  const token = localStorage.getItem('token');
  if (token && config.headers) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api_.interceptors.response.use((originalResponse) => {
  handleAxiosDates(originalResponse.data);
  return originalResponse;
}, forceLogoutOnInvalidSession);

export const api_session = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

api_session.interceptors.request.use((config: AxiosRequestConfig) => {
  const sessionToken = sessionStorage.getItem('token');
  if (sessionToken && config.headers)
    config.headers.Authorization = `Bearer ${sessionToken}`;
  return config;
});

api_session.interceptors.response.use((originalResponse) => {
  handleAxiosDates(originalResponse.data);
  return originalResponse;
}, forceLogoutOnInvalidSession);
